import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postReasonCodeSlice = createApi(`PostReasonCodeSlice`,"POST");

const PostReasonCodeSlice = createSlice({
  name: 'PostReasonCodeSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postReasonCodeSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postReasonCodeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postReasonCodeSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostReasonCodeSlice.reducer;